{
  "coursera-title": "Coursera",
  "coursera-description": "Coursera är en världstäckande e-lärandeplattform som grundades 2012 av två professorer i datavetenskap på Stanford, Andrew Ng and Daphne Koller, som erbjuder stora öppna onlinekurser, specialiseringar och examen.",
  "In use": "I användning",
  "Licenses": "Licenser",
  "Total": "Totalt",
  "E-mail address": "E-post",
  "License Status": "Licensstatus",
  "Filter by Status": "Filtrera på status",
  "All Statuses":"Välj",
  "Invited": "Inbjuden",
  "Joined": "Ansluten",
  "Cancelled": "Avbruten",
  "User Id": "AnvändarId",
  "email": "E-mail",
  "enrollment-status": "Status",
  "revoke": "Återkalla",
  "approve": "Godkänn",
  "approved": "Godkänd",
  "pending-approval": "Väntar på godkännande",
  "revoked": "Återkallats"
}
